import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  useGetProductReleaseFeaturesQuery,
} from '../../redux-modules/service';
import { Select } from '../../components/ui/view/Select';
import { SliderCards } from '../../components/ui/view/SliderCards';
import { Download } from '../../components/ui/icon/Download';
import { FileLines } from '../../components/ui/icon/FileLines';
// import { ShareFromSquare } from '../../components/ui/icon/ShareFromSquare';
import { VideoIframe } from '../../components/ui/view/VideoIframe';
import { ShowMoreLink } from '../../components/ui/view/ShowMoreLink';
import { Picture } from '../../components/ui/Picture';
import { ShareFromSquare } from '../../components/ui/icon/ShareFromSquare';
import { Link } from '../../components/ui/icon/Link';

function ProductDetailReleaseFeatures({
  productId,
  loadingText,
}) {
  const [selectedVersion, setSelectedVersion] = useState('');
  const [limit, setLimit] = useState(5);
  const {
    data,
    isFetching,
  } = useGetProductReleaseFeaturesQuery({ productId, version: selectedVersion });

  if (isFetching) {
    return (<div className="container">{loadingText}</div>);
  }

  let { releaseFeatures: items } = data;
  const {
    currentVersion,
    availableVersions,
    total,
    translates,
  } = data;
  const { product } = translates;
  items = items.slice(0, limit);

  return (
    <div className="section-main">
      <div className="container">
        <div className="section-main-head">
          <div className="row align-item-center">
            <div className="col-12 col-lg">
              <h2>{Craft.t(product, 'Release features')}</h2>
            </div>

            <div className="col-12 col-lg">
              <form className="form-filter-card">
                <label htmlFor="product-release-features-version">{Craft.t(product, 'Features for')}</label>
                <Select
                  id="product-release-features-version"
                  value={selectedVersion}
                  onChange={(e) => setSelectedVersion(e.target.value)}
                >
                  {availableVersions.map((version) => (
                    <option key={version} value={version}>{version}</option>
                  ))}
                </Select>
              </form>
            </div>

          </div>
        </div>

        {items.map((releaseFeature) => (
          <div key={releaseFeature.id} className="popup-holder">
            <div className="main-modal rounded" id={`release-feature-modal-${releaseFeature.id}`}>
              <div className="main-modal-close-head" />
              <div className="video-wrap ratio ratio-16x9">
                <div className="bg-wrap">
                  {releaseFeature.modal.thumbnailUrl ? (
                    <img src={releaseFeature.modal.thumbnailUrl} alt="" loading="lazy" />
                  ) : (
                    <Picture image={releaseFeature.modal} alt={releaseFeature.displayTitle} defaultTransform="lg-min" loading="lazy" />
                  )}
                </div>

                {releaseFeature.videoIframeSrc && (
                  <VideoIframe src={releaseFeature.videoIframeSrc} />
                )}
              </div>

              <ul className="list-meta">
                <li>{Craft.t(product, 'Release feature')}</li>
                <li>{Craft.t(product, 'Version {version}', { version: currentVersion.title })}</li>
              </ul>
              <h3>{releaseFeature.displayTitle}</h3>
              {/* eslint-disable-next-line react/no-danger */}
              <div className="text-black" dangerouslySetInnerHTML={{ __html: releaseFeature.description }} />

              {releaseFeature.videoIframeSrc && (
                <div className="position-relative">
                  <div className="btn-wrap">
                    <button
                      className="btn-share dropdown-toggle icon-link"
                      type="button"
                      data-bs-toggle="dropdown"
                      data-bs-auto-close="outside"
                      aria-expanded="false"
                    >
                      <ShareFromSquare />
                      <span>
                        &nbsp;
                        {Craft.t(product, 'Share')}
                      </span>
                    </button>
                    <div className="drop-share dropdown-menu">
                      <ul className="list-share">
                        <li>
                          <button type="button" data-clipboard-text={releaseFeature.videoIframeSrc}>
                            <Link />
                            <span>{Craft.t(product, 'Copy "{provider}" link', { provider: releaseFeature.videoProvider })}</span>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}

        <div className="row spacer-lg">
          <div className="col-12 col-lg-6 mb-4a mb-lg-0">
            {items.length > 0 && (
              <div className="card-hero">
                <a className="main-modal-opener" href={`#release-feature-modal-${items[0].id}`}>
                  <div className="card-visual">
                    {items[0].thumbnail.thumbnailUrl ? (
                      <img src={items[0].thumbnail.thumbnailUrl} alt="" loading="lazy" />
                    ) : (
                      <Picture image={items[0].thumbnail} alt={items[0].displayTitle} defaultTransform="xl-min" loading="lazy" />
                    )}
                    {/* <span className="mark-video">{items[0].duration}</span> */}
                  </div>
                </a>
                <div className="card-body">
                  <div className="card-head">
                    <h3>{items[0].displayTitle}</h3>
                  </div>
                  {/* eslint-disable-next-line react/no-danger */}
                  <div className="card-description" dangerouslySetInnerHTML={{ __html: items[0].description }} />
                  <div className="btn-wrap">
                    {currentVersion.firmwareUrl && (
                      <a className="btn btn-primary" href={currentVersion.firmwareUrl} target="_blank" rel="noreferrer">
                        <Download />
                        {Craft.t(product, 'Download firmware')}
                      </a>
                    )}

                    {currentVersion.hasReleaseNotes && (
                      <a className="btn btn-outline-dark main-modal-opener" href={`#modal-version-release-notes-${currentVersion.id}`}>
                        <FileLines />
                        {Craft.t(product, 'Release notes')}
                      </a>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="col-12 col-lg-6">
            <SliderCards>
              {items.length > 1 && items.slice(1).map((releaseFeature) => (
                <div key={releaseFeature.id}>
                  <div className="card-feature">
                    <a className="main-modal-opener" href={`#release-feature-modal-${releaseFeature.id}`}>
                      <div className="card-visual">
                        {releaseFeature.thumbnail.thumbnailUrl ? (
                          <img src={releaseFeature.thumbnail.thumbnailUrl} alt="" loading="lazy" />
                        ) : (
                          <Picture image={releaseFeature.thumbnail} alt={releaseFeature.displayTitle} defaultTransform="xl-min" loading="lazy" />
                        )}
                      </div>
                    </a>
                    <div className="card-body">
                      <h3>{releaseFeature.displayTitle}</h3>
                    </div>
                  </div>
                </div>
              ))}
            </SliderCards>
            {limit < total && (
              <ShowMoreLink label={Craft.t(product, 'Show all release videos')} onClick={() => setLimit(total)} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

ProductDetailReleaseFeatures.propTypes = {
  productId: PropTypes.string.isRequired,
  loadingText: PropTypes.string.isRequired,
};

export { ProductDetailReleaseFeatures };
